import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { fillColorAtSubstance } from "../../../../../utils/textUtils";
import { typeInfo } from "../../../../../constants/typeInfo";

import UnknownSwitch from "./UnknownSwitch";

const VocaCardFront = ({ currentPage, currentIndex, clickSwitch }) => {
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (currentIndex === 0) {
      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
      }, 5000);
    }
  }, [currentIndex]);

  return (
    <div
      style={{
        transform: isMobile ? "scale(0.5)" : "scale(1)",
        transformOrigin: "center",
        position: "absolute",
        width: isMobile ? "200%" : "100%",
        backfaceVisibility: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          border: "1px solid #EBEBEB",
          borderRadius: "10px",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            alignSelf: "stretch",
            backgroundColor: "#EBEBEB",
            padding: "16px",
            gap: "12px",
          }}
        >
          <div
            style={{
              fontSize: "60px",
              fontWeight: "bold",
              color: typeInfo["vocabulary"].color,
            }}
          >
            {currentPage.word}
          </div>
          <div
            style={{
              fontSize: "32px",
              color: "#2D2D2D",
              marginBottom: "8px",
            }}
          >
            {currentPage.pron}
          </div>
        </div>
        <div
          style={{
            padding: "16px",
            fontSize: "28px",
            lineHeight: "1.6",
          }}
        >
          {currentPage.kor.split("\n").map((line, index) => (
            <div key={index}>
              {fillColorAtSubstance(line, typeInfo["vocabulary"].color)}
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "16px",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-80px",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            color: "white",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "16px",
            whiteSpace: "nowrap",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
            opacity: showTooltip ? 1 : 0, // 투명도 애니메이션 적용
            transform: showTooltip ? "translateY(0)" : "translateY(-5px)", // 부드러운 등장
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          모르는 단어로 설정하면, 모아서 보여줘요!
        </div>
        <UnknownSwitch
          key={"switch_" + currentPage.word}
          initChecked={currentPage.isUnknown}
          onChange={clickSwitch}
        />
      </div>
    </div>
  );
};

export default VocaCardFront;
